import React, { useEffect, useState } from 'react'
import { Button } from '@material-tailwind/react';
import { addNewUnitApi, updateUnitApi } from 'api/unit';

function UnitForm({ closePopup, unitFormAction, showToast, selectedUnit }) {
  const [unitName, setUnitName] = useState('')

  useEffect(() => {
    getInitialData()
  }, [selectedUnit])

  const getInitialData = () => {
    try {
      if (selectedUnit) {
        setUnitName(selectedUnit.Name || '')
      } else {
        setUnitName('')
      }
    }
    catch (err) {
      console.log(err)
    }
  }

  const handleAddUnit = async () => {
    try {
      await addNewUnitApi(unitName)
      showToast('success', 'Unité ajoutée')
      closePopup("Reload");
    }
    catch (err) {
      showToast('error', `${err?.response?.data?.error}`)
    }
  }

  const handleEditeUnit = async () => {
    try {
      await updateUnitApi(unitName, selectedUnit._id)
      showToast('success', 'Unité modifiée')
      closePopup("Reload");
    }
    catch (err) {
      showToast('error', `${err?.response?.data?.error}`)
    }
  }

  const handleCancelOp = () => {
    closePopup("Close");
  };

  return (
    <form>
      <div className="mt-2 grid grid-cols-1 gap-5 md:grid-cols-3">
        <div>
          <label htmlFor="" className="text-md font-bold text-navy-700">
            Nom de l'unité
          </label>
          <input
            type="text"
            id=""
            placeholder="Nom de l'unité"
            className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
            value={unitName}
            disabled={unitFormAction === "show"}
            onChange={e => setUnitName(e.target.value)}
          />
        </div>
      </div>

      {
        unitFormAction === "edite" &&
        <div className="mt-5">
        <Button
          variant="gradient"
          color="#236571"
          onClick={() => handleEditeUnit()}
          className="mr-1"
        >
          <span>Modifier</span>
        </Button>
        <Button
          variant="text"
          color="#cf503f"
          onClick={() => handleCancelOp()}
          className="mr-1"
        >
          <span>Annuler</span>
        </Button>
        </div>
      }

      {
        unitFormAction === "add" &&
        <div className="mt-5">
        <Button
          variant="gradient"
          color="#236571"
          onClick={() => handleAddUnit()}
          className="mr-1"
        >
          <span>Ajouter</span>
        </Button>
        <Button
          variant="text"
          color="#cf503f"
          onClick={() => handleCancelOp()}
          className="mr-1"
        >
          <span>Annuler</span>
        </Button>
        </div>
      }
    </form>
  )
}

export default UnitForm
